import ListFiltersBar from './ListFiltersBar'

export default ListFiltersBar
